<script setup>

import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import {onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import axios from "axios";
import ContactForm from "@/components/ContactForm.vue";
import {useHead} from "@vueuse/head";

const datalist = ref({})
const route = useRoute()

function getToUrl(param) {
  let url = '/api/blogs/'
  url = url + '?site=' + param
  axios
      .get(url)
      .then(response => {
        datalist.value = response.data.results[0]
      })
      .catch(error => {
        console.log(error)
      })
}

function formatDate(dateString) {
  const date = new Date(dateString);
  return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
}

onMounted(() => {
  const param = route.params.str;
  getToUrl(param);
  const scripts = [
    '/static/js/jquery-3.6.0.min.js',
    '/static/js/bootstrap.min.js',
    '/static/js/popper.min.js',
    '/static/js/magnific-popup.min.js',
    '/static/js/slick.min.js',
    '/static/js/counterup.min.js',
    '/static/js/waypoints.min.js',
    '/static/js/jquery-ui-min.js',
    '/static/js/jquery.nice-select.min.js',
    '/static/js/theia-sticky-sidebar.min.js',
    '/static/js/main1.js'
  ];

  function loadScriptsSequentially(scripts, index = 0) {
    if (index < scripts.length) {
      const script = document.createElement('script');
      script.src = scripts[index];
      script.onload = () => loadScriptsSequentially(scripts, index + 1);
      document.body.appendChild(script);
    }
  }

  loadScriptsSequentially(scripts);
})

watch(datalist, (newVal) => {
  if (newVal) {
    useHead({
      title: newVal.title,
      meta: [
        {
          name: 'keywords',
          content: newVal.title
        },
        {
          name: 'description',
          content: newVal.title
        }
      ]
    })
  }
})

</script>

<template>
  <Header/>
  <div class="lt-breadcrumb">
    <div class="breadcrumb-content">
      <div class="container">
        <div class="d-flex justify-content-between">
          <div class="title">
            <h1>Blog Details</h1>
          </div>
          <ol class="breadcrumb align-self-center">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">Blog Details</li>
          </ol>
        </div>
      </div><!-- /.container -->
    </div><!-- /.breadcrumb-content -->
  </div><!-- /.lt-breadcrumb -->

  <div class="lt-page-content bg-color">
    <div class="lt-section">
      <div class="section-content lt-blog blog-details section-padding">
        <div class="container">
          <div class="row">
            <div class="col-md-11 col-lg-11 lt-sticky">
              <div class="theiaStickySidebar">
                <div class="tl-post">
                  <div class="entry-header">
                    <h2 v-if="datalist" class="entry-title">{{ datalist.title }}</h2>
                    <div class="entry-meta">
                      <ul class="global-list">
                        <li v-if="datalist"><span class="mr-1 fa fa-clock-o"></span>{{
                            formatDate(datalist.updated_at)
                          }}
                        </li>
                      </ul>
                    </div>
                    <div class="entry-thumbnail">
                      <img v-if="datalist" :src="datalist.image" alt="Image" class="img-fluid" style="height: 500px">
                    </div>
                  </div>
                  <div class="entry-content">
                    <p v-if="datalist" v-html="datalist.description"></p>
                  </div>
                  <div class="entry-footer justify-content-between">
                    <div class="tagcloud">
                      <a v-if="datalist" href="#">{{ datalist.tag }}</a>
                    </div>
                  </div>
                </div><!-- /.tl-post  -->

                <div class="lt-comment-form bg-white sub-section">
                  <h3 class="lt-title">Leave a Comment</h3>
                  <p>Your email address will not be published. Required fields are marked <span>*</span></p>
                  <ContactForm/>
                </div><!-- /.lt-comment-form -->
              </div>
            </div>
          </div><!-- /.row -->
        </div><!-- /.container -->
      </div><!-- /.section-content -->
    </div><!-- /.lt-section -->
  </div><!-- /.lt-page-content -->
  <Footer/>
</template>

<style scoped lang="scss">

</style>